import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import type { InvoiceCommentWithDate } from "~/modules/billing/api/invoiceComment/invoiceCommentTypes.ts";
import {
	ALL_PROCESSED_INVOICES_QUERY_KEY,
	processedInvoiceQueries,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import UpdateInvoiceCommentForm
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateInvoiceCommentSidebar/UpdateInvoiceCommentForm";

type Props = {
	comment?: InvoiceCommentWithDate;
	invoiceId: string;
	projectId: string | null;
	isOpen: boolean;
	onClose: () => void;
};

const UpdateInvoiceCommentSidebar: React.FunctionComponent<Props> = ({
	comment,
	invoiceId,
	isOpen,
	onClose,
	projectId,
}) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: processedInvoiceQueries.details(invoiceId).queryKey });
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		if (projectId) {
			queryClient.invalidateQueries({ queryKey: processedInvoiceQueries.byProject(projectId).queryKey });
		}
		onClose();
	}, [invoiceId, onClose, projectId, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			{isOpen && comment && <UpdateInvoiceCommentForm comment={comment}
															onCancel={onClose}
															onSuccess={handleSuccess} />}
		</Sidebar>
	);
};

export default UpdateInvoiceCommentSidebar;
